import { Base } from "../Base";
import { Restriction } from "./Restriction";
export class Class extends Base {
    allowed;
    class = "boolean";
    name = "boolean";
    get definition() {
        return Object.assign(super.definition, this.allowed === undefined ? {} : { allowed: this.allowed });
    }
    constructor(allowed) {
        super();
        this.allowed = allowed;
    }
    is(value) {
        return typeof value == "boolean";
    }
    restrict(...restriction) {
        return super.restrict(...(Base.Restriction.is(restriction) ? restriction : Restriction.convert(restriction)));
    }
    static create(allowed) {
        const result = new Class(allowed);
        return allowed == undefined ? result : result.restrict(allowed);
    }
}
//# sourceMappingURL=Class.js.map